import OrdersList from './OrdersList.styled';

export default OrdersList;
